import graphql from "babel-plugin-relay/macro";

import { useMutationWithError } from "../../../../../../../../utils/hooks/useMutationWithError";
import { UpdateSingleSlotBookingInput } from "./__generated__/useUpdateSingleSlotBookingMutation.graphql";

export const useUpdateSingleSlotBookingMutation = () => {
  const [updateBooking, isUpdating] = useMutationWithError(
    useUpdateSingleSlotBookingMutationString
  );

  const handleUpdateBooking = (
    input: UpdateSingleSlotBookingInput,
    successCallback?: () => void
  ) =>
    updateBooking({
      variables: { input },
      onCompleted: (res: any) => (successCallback ? successCallback() : null),
    });

  return [handleUpdateBooking, isUpdating] as const;
};

const useUpdateSingleSlotBookingMutationString = graphql`
  mutation useUpdateSingleSlotBookingMutation(
    $input: UpdateSingleSlotBookingInput!
  ) {
    responsePayload: updateSingleSlotBooking(input: $input) {
      errors {
        code

        message
        field
      }
      success
      booking {
        id
        canUpdate
        notesFromMember
        ... on StandardBooking {
          request {
            id
            time
            minTime
            maxTime
          }
        }
        rounds {
          edges {
            node {
              id
              __typename
              cartNumber
              courseLayout {
                id
                code
                name
              }
              transportationType {
                id
                code
              }
              secondaryTransportationType {
                id
                code
              }
              player {
                email
                firstName
                lastName
                id
                profileImage {
                  # TODO(ENG-3436): Remove the publicId alias when legacy image props are retired.
                  publicId: renderingKey
                }
              }

              ... on MemberRound {
                paymentStatus
                nonPlayingHost
              }
              ... on GuestRound {
                paymentStatus
                host {
                  id
                }
              }
            }
          }
        }
      }
    }
  }
`;
